export default __webpack_public_path__ + "static/pikralida-dc5f7c931b1c108217dfcef82d91a408.png";